// ================================================================================
// link-stync-none.js
// barba.js 適用しない用のスクリプトファイル
// ================================================================================

export default function linkSyncNone() {

	let irLink = document.getElementsByTagName('a');

	for (var i = 0; i < irLink.length; i++) {
		var href = irLink[i].getAttribute('href');
		if (href && href.indexOf('/ir/') !== -1) {
			irLink[i].classList.add('js-sync-none');
		}
	}

}
